import { bus } from '@core/events/eventSystem';
import { getStore } from '@core/store';
import { EVENTS, ENDPOINTS } from './constants';
import constants from '@core/utils/constants';
import { serializer as restaurantSerializer } from '@features/restaurants/serializer';

bus.on(EVENTS.RESTAURANT_SEARCH.REQUEST, async (payload) => {
  console.log('[RestaurantSearchController] REQUEST event received:', payload);

  const store = getStore('restaurantSearch');
  if (!store) {
    console.error(
      '[RestaurantSearchController] restaurantSearch store not found'
    );
    return;
  }

  bus.emit(EVENTS.RESTAURANT_SEARCH.LOADING);

  try {
    const { searchQuery, filters = {}, page = 1 } = payload;
    const { categoryId, sort, minPrice, maxPrice } = filters;

    const params = new URLSearchParams();
    if (searchQuery) params.append('search', searchQuery);
    if (categoryId) params.append('categoryId', categoryId);

    if (minPrice !== undefined) params.append('priceMin', minPrice.toString());
    if (maxPrice !== undefined) params.append('priceMax', maxPrice.toString());

    const limit = 2000;
    const offset = (page - 1) * limit;
    params.append('limit', limit.toString());
    params.append('offset', offset.toString());

    // Use global restaurant list if no filters or search query is applied.
    let url = '';
    if (
      !searchQuery &&
      !categoryId &&
      minPrice === undefined &&
      maxPrice === undefined
    ) {
      url = `${ENDPOINTS.RESTAURANT_LIST}&${params.toString()}`;
    } else {
      url = `${ENDPOINTS.RESTAURANT_SEARCH}&${params.toString()}`;
    }

    bus.emit(constants.EVENTS.NETWORK.REQUEST, {
      id: `restaurant-search-${Date.now()}`,
      url,
      method: 'GET'
    });

    const responseHandler = (res) => {
      if (res.id.startsWith('restaurant-search-')) {
        bus.off(constants.EVENTS.NETWORK.RESPONSE, responseHandler);
        console.log('[RestaurantSearchController] Response received:', res);

        if (res.success) {
          const responseData = res.data;
          const items = responseData?.data?.data || responseData?.data || responseData || [];
          const totalCount =
            responseData?.total ||
            responseData?.count ||
            res.count ||
            (Array.isArray(items) ? items.length : 0);

          const restaurants = (Array.isArray(items) ? items : [])
            .map((item) => restaurantSerializer.deserializeRestaurant(item))
            .filter((r) => r && r.id)
            .filter((r) => {
              console.log("🚀 ~ responseHandler ~ searchQuery:", searchQuery)
              return r.storeName.toLowerCase().includes(searchQuery.toLowerCase().trim());
            });
          console.log("🚀 ~ responseHandler ~ restaurants:", restaurants)

          bus.emit(EVENTS.RESTAURANT_SEARCH.LOADED, {
            restaurants,
            hasMore: items.length >= limit,
            page: page,
            totalCount: totalCount
          });
        } else {
          bus.emit(EVENTS.RESTAURANT_SEARCH.ERROR, {
            message:
              res.data?.message || 'Erreur lors de la recherche de restaurants'
          });
        }
      }
    };

    bus.on(constants.EVENTS.NETWORK.RESPONSE, responseHandler);
  } catch (error) {
    console.error('[RestaurantSearchController] Error during search:', error);
    bus.emit(EVENTS.RESTAURANT_SEARCH.ERROR, error);
  }
});

bus.on(EVENTS.RESTAURANT_SEARCH.LOAD_MORE, async () => {
  console.log('[RestaurantSearchController] LOAD_MORE event received');

  const store = getStore('restaurantSearch');
  if (!store) return;

  const currentState = store.state;

  if (!currentState.hasMore || currentState.loading) return;

  bus.emit(EVENTS.RESTAURANT_SEARCH.LOADING_MORE);

  try {
    const { searchQuery, filters = {}, page } = currentState;
    const { categoryId, sort, minPrice, maxPrice } = filters;

    const params = new URLSearchParams();
    const nextPage = page + 1;

    if (searchQuery) params.append('search', searchQuery);
    if (categoryId) params.append('categoryId', categoryId);

    if (minPrice !== undefined) params.append('priceMin', minPrice.toString());
    if (maxPrice !== undefined) params.append('priceMax', maxPrice.toString());

    const limit = 20;
    const offset = (nextPage - 1) * limit;
    params.append('limit', limit.toString());
    params.append('offset', offset.toString());

    let url = '';
    if (
      !searchQuery &&
      !categoryId &&
      minPrice === undefined &&
      maxPrice === undefined
    ) {
      url = `${ENDPOINTS.RESTAURANT_LIST}&${params.toString()}`;
    } else {
      url = `${ENDPOINTS.RESTAURANT_SEARCH}&${params.toString()}`;
    }

    bus.emit(constants.EVENTS.NETWORK.REQUEST, {
      id: `restaurant-search-more-${Date.now()}`,
      url,
      method: 'GET'
    });

    const responseHandler = (res) => {
      if (res.id.startsWith('restaurant-search-more-')) {
        bus.off(constants.EVENTS.NETWORK.RESPONSE, responseHandler);

        if (res.success) {
          const responseData = res.data;
          const items = responseData?.data || responseData || [];
          const totalCount =
            responseData?.total ||
            responseData?.count ||
            res.count ||
            currentState.totalCount;

          const restaurants = (Array.isArray(items) ? items : [])
            .map((item) => restaurantSerializer.deserializeRestaurant(item))
            .filter((r) => r && r.id);

          bus.emit(EVENTS.RESTAURANT_SEARCH.LOADED_MORE, {
            restaurants,
            hasMore: items.length >= limit,
            totalCount: totalCount,
            page: nextPage
          });
        } else {
          bus.emit(EVENTS.RESTAURANT_SEARCH.ERROR, {
            message: res.data?.message || 'Erreur lors du chargement'
          });
        }
      }
    };

    bus.on(constants.EVENTS.NETWORK.RESPONSE, responseHandler);
  } catch (error) {
    bus.emit(EVENTS.RESTAURANT_SEARCH.ERROR, error);
  }
});

console.log('[RestaurantSearchController] Controller loaded successfully');
